import styles from "./hero-full-width-image.module.less";
import type { TImage } from "../../../types";
import { getImageLoading } from "../../../helpers";
import { useIntersectionObserver } from "usehooks-ts";
import animations from "../../../animation/animation.module.less";

type THeroFullWidthImageProps = {
  imageDesktop?: TImage;
  imageMobile?: TImage;
  enableImageOverlay?: boolean;
  blockIndex?: number;
  fallbackDesktopImage?: string;
};

const HeroFullWidthImage = ({
  imageDesktop,
  imageMobile,
  enableImageOverlay,
  blockIndex,
  fallbackDesktopImage,
}: THeroFullWidthImageProps) => {
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0,
    freezeOnceVisible: true,
  });

  const animationClasses = [
    blockIndex === 0 ? animations.fadeIn400 : isIntersecting ? animations.fadeIn400 : "",
    animations.opacity0,
  ].join(" ");

  return (
    <div ref={ref} className={animationClasses}>
      {enableImageOverlay && <div className={styles.imageOverlay} />}
      <div className={[styles.fullWidthImageWrapper, enableImageOverlay ? styles.enableImageOverlay : ""].join(" ")}>
        {(imageDesktop?.url || imageMobile?.url) && (
          <picture>
            <source srcSet={imageMobile?.url} media="(max-width: 767px)" />
            <source srcSet={imageDesktop?.url || fallbackDesktopImage} media="(min-width: 768px)" />
            <img
              src={imageDesktop?.url || fallbackDesktopImage}
              className={styles.image}
              alt={imageMobile?.alt || imageDesktop?.alt}
              loading={getImageLoading(blockIndex)}
            />
          </picture>
        )}
      </div>
    </div>
  );
};

export default HeroFullWidthImage;
